// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Jv1x","content":"styles_content__KdqeH","row":"styles_row__3S95b","footer":"styles_footer__1TTxr","phraseLength":"styles_phraseLength__3jKVH"};